module.exports = __webpack_public_path__ + "inputs/img/eps.c9f8fb3e.png";